<template>
  <div v-if="purchases && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint :formater="formater" :datas="purchases" />
  </div>
</template>
<script>
import Delevery from "@/api/delivery";
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    purchases: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("purchase").then(
      function (response) {
        if (response.data.status.isOK()) {
          // console.log(response);
          var formater = response.data.print_template.template;
          this.formater = formater;

          //获取单据详情
          Delevery.batchPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                if (response.data.purchases)
                  this.purchases = response.data.purchases.map(
                    function (purchase) {
                      purchase.purchase_details = purchase.purchase_details.map(
                        (detail) => {
                          if (detail.negotiate_price_flg == 1) {
                            // 显示后议价
                            // 单价
                            detail.price = this.$t(
                              "DeliveryDetail.Fields.negotiatePrices"
                            );
                            // 采购金额
                            detail.total = this.$t(
                              "DeliveryDetail.Fields.negotiatePrices"
                            );
                          }
                          return detail;
                        }
                      );
                      purchase.delivery_info = this.$printUtils.addCitiesName(
                        purchase.delivery_info
                      );
                      return purchase;
                    }.bind(this)
                  );
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>